import {
    Button,
    ButtonProps
} from "@mantine/core";
import {AiOutlineCamera} from "react-icons/ai";
import {useParams} from "react-router-dom";
import {useRetakeApplicationScreenshotMutation} from "../hooks/useApplicationScreenshotsQuery.ts";

export const RetakeButton = (props: ButtonProps) => {

    const {id: screenshotId} = useParams();
    const retakeMutation = useRetakeApplicationScreenshotMutation();

    const handleRetake = () => {
        if (screenshotId) {
            retakeMutation.mutateAsync(screenshotId);
        }
    };

    return (
        <Button
            leftSection={<AiOutlineCamera/>}
            onClick={handleRetake}
            loading={retakeMutation.isPending}
            variant={'filled'}
            {...props}
        >Retake</Button>
    );
};
